module.exports = __webpack_public_path__ + "static/img/neonbrand-570366-unsplash.71e845e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/neonbrand-570366-unsplash.jpg
// module id = kVTM
// module chunks = 1